import { Logger } from "../../Misc/logger.js";
var WebGPUBindGroupCacheNode = /** @class */ (function () {
    function WebGPUBindGroupCacheNode() {
        this.values = {};
    }
    return WebGPUBindGroupCacheNode;
}());
/** @hidden */
var WebGPUCacheBindGroups = /** @class */ (function () {
    function WebGPUCacheBindGroups(device, cacheSampler, engine) {
        this.disabled = false;
        this._device = device;
        this._cacheSampler = cacheSampler;
        this._engine = engine;
    }
    Object.defineProperty(WebGPUCacheBindGroups, "Statistics", {
        get: function () {
            return {
                totalCreated: WebGPUCacheBindGroups.NumBindGroupsCreatedTotal,
                lastFrameCreated: WebGPUCacheBindGroups.NumBindGroupsCreatedLastFrame,
                lookupLastFrame: WebGPUCacheBindGroups.NumBindGroupsLookupLastFrame,
                noLookupLastFrame: WebGPUCacheBindGroups.NumBindGroupsNoLookupLastFrame,
            };
        },
        enumerable: false,
        configurable: true
    });
    WebGPUCacheBindGroups.prototype.endFrame = function () {
        WebGPUCacheBindGroups.NumBindGroupsCreatedLastFrame = WebGPUCacheBindGroups._NumBindGroupsCreatedCurrentFrame;
        WebGPUCacheBindGroups.NumBindGroupsLookupLastFrame = WebGPUCacheBindGroups._NumBindGroupsLookupCurrentFrame;
        WebGPUCacheBindGroups.NumBindGroupsNoLookupLastFrame = WebGPUCacheBindGroups._NumBindGroupsNoLookupCurrentFrame;
        WebGPUCacheBindGroups._NumBindGroupsCreatedCurrentFrame = 0;
        WebGPUCacheBindGroups._NumBindGroupsLookupCurrentFrame = 0;
        WebGPUCacheBindGroups._NumBindGroupsNoLookupCurrentFrame = 0;
    };
    /**
     * Cache is currently based on the uniform/storage buffers, samplers and textures used by the binding groups.
     * Note that all uniform buffers have an offset of 0 in Babylon and we don't have a use case where we would have the same buffer used with different capacity values:
     * that means we don't need to factor in the offset/size of the buffer in the cache, only the id
     * @param webgpuPipelineContext
     * @param drawContext
     * @param materialContext
     */
    WebGPUCacheBindGroups.prototype.getBindGroups = function (webgpuPipelineContext, drawContext, materialContext) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var bindGroups = undefined;
        var node = WebGPUCacheBindGroups._Cache;
        var cacheIsDisabled = this.disabled || materialContext.forceBindGroupCreation;
        if (!cacheIsDisabled) {
            if (!drawContext.isDirty(materialContext.updateId) && !materialContext.isDirty) {
                WebGPUCacheBindGroups._NumBindGroupsNoLookupCurrentFrame++;
                return drawContext.bindGroups;
            }
            for (var _i = 0, _l = webgpuPipelineContext.shaderProcessingContext.bufferNames; _i < _l.length; _i++) {
                var bufferName = _l[_i];
                var uboId = (_b = (_a = drawContext.buffers[bufferName]) === null || _a === void 0 ? void 0 : _a.uniqueId) !== null && _b !== void 0 ? _b : 0;
                var nextNode = node.values[uboId];
                if (!nextNode) {
                    nextNode = new WebGPUBindGroupCacheNode();
                    node.values[uboId] = nextNode;
                }
                node = nextNode;
            }
            for (var _m = 0, _o = webgpuPipelineContext.shaderProcessingContext.samplerNames; _m < _o.length; _m++) {
                var samplerName = _o[_m];
                var samplerHashCode = (_d = (_c = materialContext.samplers[samplerName]) === null || _c === void 0 ? void 0 : _c.hashCode) !== null && _d !== void 0 ? _d : 0;
                var nextNode = node.values[samplerHashCode];
                if (!nextNode) {
                    nextNode = new WebGPUBindGroupCacheNode();
                    node.values[samplerHashCode] = nextNode;
                }
                node = nextNode;
            }
            for (var _p = 0, _q = webgpuPipelineContext.shaderProcessingContext.textureNames; _p < _q.length; _p++) {
                var textureName = _q[_p];
                var textureId = (_g = (_f = (_e = materialContext.textures[textureName]) === null || _e === void 0 ? void 0 : _e.texture) === null || _f === void 0 ? void 0 : _f.uniqueId) !== null && _g !== void 0 ? _g : 0;
                var nextNode = node.values[textureId];
                if (!nextNode) {
                    nextNode = new WebGPUBindGroupCacheNode();
                    node.values[textureId] = nextNode;
                }
                node = nextNode;
            }
            bindGroups = node.bindGroups;
        }
        drawContext.resetIsDirty(materialContext.updateId);
        materialContext.isDirty = false;
        if (bindGroups) {
            drawContext.bindGroups = bindGroups;
            WebGPUCacheBindGroups._NumBindGroupsLookupCurrentFrame++;
            return bindGroups;
        }
        bindGroups = [];
        drawContext.bindGroups = bindGroups;
        if (!cacheIsDisabled) {
            node.bindGroups = bindGroups;
        }
        WebGPUCacheBindGroups.NumBindGroupsCreatedTotal++;
        WebGPUCacheBindGroups._NumBindGroupsCreatedCurrentFrame++;
        var bindGroupLayouts = webgpuPipelineContext.bindGroupLayouts;
        for (var i = 0; i < webgpuPipelineContext.shaderProcessingContext.bindGroupLayoutEntries.length; i++) {
            var setDefinition = webgpuPipelineContext.shaderProcessingContext.bindGroupLayoutEntries[i];
            var entries = webgpuPipelineContext.shaderProcessingContext.bindGroupEntries[i];
            for (var j = 0; j < setDefinition.length; j++) {
                var entry = webgpuPipelineContext.shaderProcessingContext.bindGroupLayoutEntries[i][j];
                var entryInfo = webgpuPipelineContext.shaderProcessingContext.bindGroupLayoutEntryInfo[i][entry.binding];
                var name_1 = (_h = entryInfo.nameInArrayOfTexture) !== null && _h !== void 0 ? _h : entryInfo.name;
                if (entry.sampler) {
                    var bindingInfo = materialContext.samplers[name_1];
                    if (bindingInfo) {
                        var sampler = bindingInfo.sampler;
                        if (!sampler) {
                            if (this._engine.dbgSanityChecks) {
                                Logger.Error("Trying to bind a null sampler! entry=".concat(JSON.stringify(entry), ", name=").concat(name_1, ", bindingInfo=").concat(JSON.stringify(bindingInfo, function (key, value) { return (key === "texture" ? "<no dump>" : value); }), ", materialContext.uniqueId=").concat(materialContext.uniqueId), 50);
                            }
                            continue;
                        }
                        entries[j].resource = this._cacheSampler.getSampler(sampler, false, bindingInfo.hashCode);
                    }
                    else {
                        Logger.Error("Sampler \"".concat(name_1, "\" could not be bound. entry=").concat(JSON.stringify(entry), ", materialContext=").concat(JSON.stringify(materialContext, function (key, value) {
                            return key === "texture" || key === "sampler" ? "<no dump>" : value;
                        })), 50);
                    }
                }
                else if (entry.texture || entry.storageTexture) {
                    var bindingInfo = materialContext.textures[name_1];
                    if (bindingInfo) {
                        if (this._engine.dbgSanityChecks && bindingInfo.texture === null) {
                            Logger.Error("Trying to bind a null texture! entry=".concat(JSON.stringify(entry), ", bindingInfo=").concat(JSON.stringify(bindingInfo, function (key, value) {
                                return key === "texture" ? "<no dump>" : value;
                            }), ", materialContext.uniqueId=").concat(materialContext.uniqueId), 50);
                            continue;
                        }
                        var hardwareTexture = bindingInfo.texture._hardwareTexture;
                        if (this._engine.dbgSanityChecks &&
                            (!hardwareTexture || (entry.texture && !hardwareTexture.view) || (entry.storageTexture && !hardwareTexture.viewForWriting))) {
                            Logger.Error("Trying to bind a null gpu texture or view! entry=".concat(JSON.stringify(entry), ", name=").concat(name_1, ", bindingInfo=").concat(JSON.stringify(bindingInfo, function (key, value) { return (key === "texture" ? "<no dump>" : value); }), ", isReady=").concat((_j = bindingInfo.texture) === null || _j === void 0 ? void 0 : _j.isReady, ", materialContext.uniqueId=").concat(materialContext.uniqueId), 50);
                            continue;
                        }
                        entries[j].resource = entry.storageTexture ? hardwareTexture.viewForWriting : hardwareTexture.view;
                    }
                    else {
                        Logger.Error("Texture \"".concat(name_1, "\" could not be bound. entry=").concat(JSON.stringify(entry), ", materialContext=").concat(JSON.stringify(materialContext, function (key, value) {
                            return key === "texture" || key === "sampler" ? "<no dump>" : value;
                        })), 50);
                    }
                }
                else if (entry.externalTexture) {
                    var bindingInfo = materialContext.textures[name_1];
                    if (bindingInfo) {
                        if (this._engine.dbgSanityChecks && bindingInfo.texture === null) {
                            Logger.Error("Trying to bind a null external texture! entry=".concat(JSON.stringify(entry), ", name=").concat(name_1, ", bindingInfo=").concat(JSON.stringify(bindingInfo, function (key, value) { return (key === "texture" ? "<no dump>" : value); }), ", materialContext.uniqueId=").concat(materialContext.uniqueId), 50);
                            continue;
                        }
                        var externalTexture = bindingInfo.texture.underlyingResource;
                        if (this._engine.dbgSanityChecks && !externalTexture) {
                            Logger.Error("Trying to bind a null gpu external texture! entry=".concat(JSON.stringify(entry), ", name=").concat(name_1, ", bindingInfo=").concat(JSON.stringify(bindingInfo, function (key, value) { return (key === "texture" ? "<no dump>" : value); }), ", isReady=").concat((_k = bindingInfo.texture) === null || _k === void 0 ? void 0 : _k.isReady, ", materialContext.uniqueId=").concat(materialContext.uniqueId), 50);
                            continue;
                        }
                        entries[j].resource = this._device.importExternalTexture({ source: externalTexture });
                    }
                    else {
                        Logger.Error("Texture \"".concat(name_1, "\" could not be bound. entry=").concat(JSON.stringify(entry), ", materialContext=").concat(JSON.stringify(materialContext, function (key, value) {
                            return key === "texture" || key === "sampler" ? "<no dump>" : value;
                        })), 50);
                    }
                }
                else if (entry.buffer) {
                    var dataBuffer = drawContext.buffers[name_1];
                    if (dataBuffer) {
                        var webgpuBuffer = dataBuffer.underlyingResource;
                        entries[j].resource.buffer = webgpuBuffer;
                        entries[j].resource.size = dataBuffer.capacity;
                    }
                    else {
                        Logger.Error("Can't find buffer \"".concat(name_1, "\". entry=").concat(JSON.stringify(entry), ", buffers=").concat(JSON.stringify(drawContext.buffers), ", drawContext.uniqueId=").concat(drawContext.uniqueId), 50);
                    }
                }
            }
            var groupLayout = bindGroupLayouts[i];
            bindGroups[i] = this._device.createBindGroup({
                layout: groupLayout,
                entries: entries,
            });
        }
        return bindGroups;
    };
    WebGPUCacheBindGroups.NumBindGroupsCreatedTotal = 0;
    WebGPUCacheBindGroups.NumBindGroupsCreatedLastFrame = 0;
    WebGPUCacheBindGroups.NumBindGroupsLookupLastFrame = 0;
    WebGPUCacheBindGroups.NumBindGroupsNoLookupLastFrame = 0;
    WebGPUCacheBindGroups._Cache = new WebGPUBindGroupCacheNode();
    WebGPUCacheBindGroups._NumBindGroupsCreatedCurrentFrame = 0;
    WebGPUCacheBindGroups._NumBindGroupsLookupCurrentFrame = 0;
    WebGPUCacheBindGroups._NumBindGroupsNoLookupCurrentFrame = 0;
    return WebGPUCacheBindGroups;
}());
export { WebGPUCacheBindGroups };
//# sourceMappingURL=webgpuCacheBindGroups.js.map